function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M19.5 10a9.5 9.5 0 11-19 0 9.5 9.5 0 0119 0z",
  stroke: "currentColor"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M10.786 7.783V15H8.854V7.783h1.932zm.231-2.051c0 .163-.033.315-.098.455a1.23 1.23 0 01-.266.371 1.149 1.149 0 01-.385.252 1.2 1.2 0 01-.469.091 1.165 1.165 0 01-.826-.343 1.294 1.294 0 01-.259-.371 1.132 1.132 0 01-.091-.455c0-.163.03-.315.091-.455.065-.145.152-.27.259-.378a1.165 1.165 0 01.826-.343c.168 0 .324.03.469.091.15.06.278.145.385.252.112.107.2.233.266.378.065.14.098.292.098.455z",
  fill: "currentColor"
});

function SvgInfoBorder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none"
  }, props), _ref, _ref2);
}

export default "/app/dist/assets/info-border.svg";
export { SvgInfoBorder as ReactComponent };